import React from 'react';
import { Link } from 'react-router-dom';
import './PageHeader.css';

export interface Crumb {
    label: React.ReactNode;
    /** Omit for a context label that is not a destination. */
    to?: string;
}

/**
 * Page title (the page's h1), optional context breadcrumb above it
 * (workspace › project › section), subtitle, and an actions slot.
 */
export function PageHeader({ title, subtitle, actions, breadcrumb, eyebrow }: {
    title: React.ReactNode;
    /** Small kicker above the title (concept `.eyebrow`, e.g. "Workspace dashboard"); CSS uppercases it. */
    eyebrow?: string;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    breadcrumb?: Crumb[];
}) {
    return (
        <div className="page-header ui-page-header">
            <div className="page-header-main">
                {breadcrumb && breadcrumb.length > 0 && (
                    <nav aria-label="Breadcrumb" className="ui-breadcrumb">
                        <ol>
                            {breadcrumb.map((c, i) => (
                                <li key={i}>{c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}</li>
                            ))}
                        </ol>
                    </nav>
                )}
                {eyebrow && <span className="page-eyebrow">{eyebrow}</span>}
                <h1 className="page-title">{title}</h1>
                {subtitle && <p className="page-subtitle">{subtitle}</p>}
            </div>
            {actions && <div className="page-header-actions">{actions}</div>}
        </div>
    );
}
